export default __webpack_public_path__ + "static/media/insta-logo.9b622839.svg";